import { ReactNode } from 'react';

import styled from 'styled-components';

import { IconDrag } from '@components/icons/drag';
import { MakePropertiesOptional } from '@utils/types';

export type IconHoverContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  hoverIcon: ReactNode;
  icon: ReactNode;
};

export const IconHoverContainer = ({ hoverIcon, icon, ...rest }: IconHoverContainerProps) => {
  return (
    <StyledIconHoverContainer {...rest}>
      {hoverIcon}
      {icon}
    </StyledIconHoverContainer>
  );
};

const StyledIconHoverContainer = styled.div({
  display: 'flex',
  'svg:first-child': {
    opacity: 0,
    position: 'absolute',
  },
  '&:hover': {
    'svg:first-child': {
      opacity: 1,
    },
    'svg:nth-child(2)': {
      opacity: 0,
    },
  },
});

type IconDragHoverProps = MakePropertiesOptional<IconHoverContainerProps, 'hoverIcon'>;

export const IconDragHover = ({ hoverIcon = <IconDrag />, icon, ...rest }: IconDragHoverProps) => {
  return (
    <IconHoverContainer icon={icon} hoverIcon={hoverIcon} style={{ cursor: 'grab' }} {...rest} />
  );
};
